import { Component } from '@angular/core';
import { Ward } from '../ward-manage/ward';
import { WardService } from 'src/app/services/ward.service';
import { professionList, vataList, khanaList } from './assessment';
import { AssessmentService } from 'src/app/services/assessment.service';
import { FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Assessment } from 'src/app/models/assessment';
import { ActivatedRoute, Router } from '@angular/router';
import { UnionService } from 'src/app/services/union.service';
import { Union } from 'src/app/models/union';
import { HttpClient } from '@angular/common/http';
import { SmsService } from 'src/app/services/sms.service';
import { UnionDomain } from 'src/app/services/union.domain';

@Component({
  selector: 'app-assessment-create',
  templateUrl: './assessment-create.component.html',
  styleUrls: ['./assessment-create.component.scss'],
})
export class AssessmentCreateComponent {
  $subscriptions: Subscription[] = [];
  wardList: Ward[] = [];
  seasons: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  assessment: Assessment = new Assessment();
  assesmentFrom!: FormGroup;
  professionList = professionList;
  vataList = vataList;
  khanaList = khanaList;
  assesmentId!: number;
  unionData!: Union;

  constructor(
    private wardService: WardService,
    private assessmentService: AssessmentService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private unionService: UnionService,
    private smsService: SmsService,
    private unionDomain: UnionDomain
  ) {}

  async ngOnInit(): Promise<void> {
    this.assesmentId = this.route.snapshot.queryParams['id'];
    await this.getUnion();
    await this.getWards();
    if (this.assesmentId && this.assessmentService.sharedAssesment) {
      this.assessmentService.sharedAssesment = false;
      this.getAssesment();
    }
  }

  ngOnDestroy(): void {
    this.$subscriptions.forEach((s) => s.unsubscribe());
  }

  getUnion = async (): Promise<void> => {
    this.$subscriptions.push(
      this.unionService.getSingleUnion().subscribe({
        next: (res) => {
          this.unionData = res;
          this.initializeForm();
        },
        error: (err) => {
          this.toastr.error(err.message);
        },
      })
    );
  };

  private initializeForm = (formData?: Assessment) => {
    this.assesmentFrom = new FormGroup({
      ward_number: new FormControl(
        formData?.ward_number ? formData.ward_number : '0',
        [Validators.required, this.validateWardSelection]
      ),
      ward_name: new FormControl(
        formData?.ward_name ? formData.ward_name : '0'
      ),
      holding_number: new FormControl(
        formData?.holding_number ? formData.holding_number : '',
        [Validators.required]
      ),
      name: new FormControl(formData?.name ? formData.name : '', [Validators.required]),
      gurdian_name: new FormControl(
        formData?.gurdian_name ? formData.gurdian_name : ''
      ),
      mobile_number: new FormControl(
        formData?.mobile_number ? formData.mobile_number : '',
        [Validators.required]
      ),
      id_number: new FormControl(formData?.id_number ? formData.id_number : ''),
      vata: new FormControl(
        formData?.vata ? formData.vata.toString() : '6',
        [Validators.required]
      ),
      pesha: new FormControl(
        formData?.pesha ? formData.pesha.toString() : '10',
        [Validators.required]
      ),
      khanar_dhoron: new FormControl(
        formData?.khanar_dhoron ? formData.khanar_dhoron.toString() : '',
        [Validators.required, this.validateKhanarDhoronSelection]
      ),
      khanar_anumanik_mullo: new FormControl({
        value: formData?.khanar_anumanik_mullo
          ? formData.khanar_anumanik_mullo
          : '',
        disabled: false,
      }, [Validators.required]),
      khanar_dharjokrito_kor: new FormControl({
        value: formData?.khanar_dharjokrito_kor
          ? formData.khanar_dharjokrito_kor
          : '',
        disabled: false,
      }, [Validators.required]),
      gram_or_rasta: new FormControl(
        formData?.gram_or_rasta ? formData.gram_or_rasta : ''
      ),
      post_office: new FormControl(
        formData?.post_office ? formData.post_office : ''
      ),
      upozilla: new FormControl({
        value: formData?.upozilla
          ? formData.upozilla
          : this.unionData.upozilla_name,
        disabled: true,
      }),
      zilla: new FormControl({
        value: formData?.zilla ? formData.zilla : this.unionData.zilla_name,
        disabled: true,
      }),
    });
  };

  getAssesment = (): void => {
    this.$subscriptions.push(
      this.assessmentService.getSingleAssesment(this.assesmentId).subscribe({
        next: (res) => {
          this.initializeForm(res);
          // Auto-populate the khanar_anumanik_mullo and khanar_dharjokrito_kor based on selected khanar_dhoron
          if (res.khanar_dhoron) {
            this.changeKhanarDhoron(Number(res.khanar_dhoron));
          }
        },
      })
    );
  };

  private getWards = async (): Promise<void> => {
    this.$subscriptions.push(
      this.wardService.getWardList().subscribe({
        next: (res: any) => {
          this.wardList = res;
        },
      })
    );
  };

  // Custom validation functions
  validateWardSelection = (control: AbstractControl): ValidationErrors | null => {
    if (control.value === '0' || control.value === 0) {
      return { invalidWardSelection: true };
    }
    return null;
  };



  validateKhanarDhoronSelection = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.value === '') {
      return { invalidKhanarDhoronSelection: true };
    }
    return null;
  };

  changeKhanarDhoron = (khanarDhoron: number): void => {
    switch (khanarDhoron) {
      case 1:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.ek_chala);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.ek_chala_kor);
        break;
      case 2:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.dui_chala);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.dui_chala_kor);
        break;
      case 3:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.char_chala);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.char_chala_kor);
        break;
      case 4:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.adha_paka);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.adha_paka_kor);
        break;
      case 5:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.paka);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.paka_kor);
        break;
      case 6:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.ek_tola);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.ek_tola_kor);
        break;
      case 7:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.dui_tola);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.dui_tola_kor);
        break;
      case 8:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.tin_tola);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.tin_tola_kor);
        break;
      case 9:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.char_tola);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.char_tola_kor);
        break;
      case 10:
        this.assesmentFrom
          .get(`khanar_anumanik_mullo`)
          ?.setValue(this.unionData.bohutol);
        this.assesmentFrom
          .get(`khanar_dharjokrito_kor`)
          ?.setValue(this.unionData.bohutol_kor);
        break;
      default:
        break;
    }
  };
  sendSms = (): void => {
    if (this.unionData.is_create_assessment_msg_on) {
      this.$subscriptions.push(
        this.smsService
          .sendAssessmentCreateSms(this.assesmentFrom.value.mobile_number)
          .subscribe({
            next: (res) => {
              if (res.response_code == 202) {
                this.toastr.success(res.success_message);
              } else {
                this.toastr.error(res.error_message);
                alert('অপর্যাপ্ত ব্যালেন্স | SMS সম্পন্ন হয়নি');
              }
              console.log(res);
            },
          })
      );
    }
  };
  onSubmit = (): void => {
    // Mark all fields as touched to show validation errors
    this.markFormGroupTouched(this.assesmentFrom);

    // Check if form is valid
    if (this.assesmentFrom.invalid) {
      // Show validation error messages
      if (this.assesmentFrom.get('ward_number')?.hasError('invalidWardSelection')) {
        this.toastr.error('অনুগ্রহ করে একটি ওয়ার্ড নির্বাচন করুন');
        return;
      }
      if (this.assesmentFrom.get('holding_number')?.hasError('required')) {
        this.toastr.error('অনুগ্রহ করে হোল্ডিং নং লিখুন');
        return;
      }
      if (this.assesmentFrom.get('name')?.hasError('required')) {
        this.toastr.error('অনুগ্রহ করে আবেদনকারীর নাম লিখুন');
        return;
      }
      if (this.assesmentFrom.get('mobile_number')?.hasError('required')) {
        this.toastr.error('অনুগ্রহ করে মোবাইল নং লিখুন');
        return;
      }
      if (this.assesmentFrom.get('vata')?.hasError('required')) {
        this.toastr.error('অনুগ্রহ করে ভাতার একটি অপশন নির্বাচন করুন');
        return;
      }
      if (this.assesmentFrom.get('pesha')?.hasError('required')) {
        this.toastr.error('অনুগ্রহ করে পেশার একটি অপশন নির্বাচন করুন');
        return;
      }
      if (this.assesmentFrom.get('khanar_dhoron')?.hasError('invalidKhanarDhoronSelection')) {
        this.toastr.error('অনুগ্রহ করে খানার ধরণের একটি অপশন নির্বাচন করুন');
        return;
      }
      if (this.assesmentFrom.get('khanar_anumanik_mullo')?.hasError('required')) {
        this.toastr.error('অনুগ্রহ করে খানার আনুমানিক মূল্য লিখুন');
        return;
      }
      if (this.assesmentFrom.get('khanar_dharjokrito_kor')?.hasError('required')) {
        this.toastr.error('অনুগ্রহ করে ধার্যকৃত কর লিখুন');
        return;
      }
      
      this.toastr.error('অনুগ্রহ করে সকল আবশ্যক তথ্য পূরণ করুন');
      return;
    }

    this.assesmentFrom.value.ward_name = this.wardList.find(
      (ward) => ward.ward_number == Number(this.assesmentFrom.value.ward_number)
    )?.ward_name;
    this.assesmentFrom.value.holding_number =
      this.unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(
        this.assesmentFrom.value.holding_number.toString()
      );
    if (this.assesmentFrom.value.mobile_number.length == 11) {
      this.assesmentFrom.value.mobile_number =
        '' + this.assesmentFrom.value.mobile_number;
    }
    if (this.assesmentId) {
      this.assesmentFrom.value.id = this.assesmentId;
      this.$subscriptions.push(
        this.assessmentService
          .updateAssesment(this.assesmentFrom.value)
          .subscribe({
            next: (res) => {
              this.toastr.success(res.message);
              this.router.navigate(['admin/assessment-page']);
            },
            error: (err) => {
              this.toastr.error(err.error.message);
            },
          })
      );
    } else {
      this.$subscriptions.push(
        this.assessmentService
          .createAssesment(this.assesmentFrom.value)
          .subscribe({
            next: (res) => {
              this.toastr.success(res.message);
              this.sendSms();
              this.initializeForm();
            },
            error: (err) => {
              this.toastr.error(err.error.message);
            },
          })
      );
    }
  };

  // Helper method to mark all form fields as touched
  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }
}
